module.exports = __webpack_public_path__ + "static/img/CCIA.ce392c2a.jpg";